import React from 'react';
import { motion } from 'framer-motion';
export function PartnersSection() {
  const partners = [{
    name: 'CQ Business Consulting Inc.',
    type: 'Lead Partner',
    logo: 'https://cdn.magicpatterns.com/uploads/8QATFbhGSHv3DUPQFaAB8y/CQBusiness.webp'
  }, {
    name: 'Pitch Better',
    type: 'Research Partner',
    logo: 'https://cdn.magicpatterns.com/uploads/waNNm6pvWwg4uSXqUqVGwP/Pitch_Better_Logo.png'
  }, {
    name: 'Government of Canada',
    type: 'Funding Partner',
    logo: 'https://cdn.magicpatterns.com/uploads/aaX5R5oSazjzhyFjd9FjFM/government-of-canada-logo.png'
  }, {
    name: 'BDC',
    type: 'Ecosystem Partner',
    logo: 'https://cdn.magicpatterns.com/uploads/88NqZm65KLXjbxW4fna2zz/images.png'
  }];
  return <section className="py-20 bg-white" data-id="element-174">
      <div className="max-w-7xl mx-auto px-6 md:px-12 text-center" data-id="element-175">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-sm font-bold text-gray-400 uppercase tracking-widest mb-12" data-id="element-176">
          Built in collaboration with
        </motion.h2>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 items-center justify-center" data-id="element-177">
          {partners.map((partner, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="flex flex-col items-center justify-center p-6 opacity-90 hover:opacity-100 transition-all duration-300" data-id="element-178">
              {partner.logo ? <div className="h-16 md:h-20 flex items-center justify-center mb-3" data-id="element-179">
                  <img src={partner.logo} alt={partner.name} className="max-h-full w-auto object-contain" data-id="element-180" />
                </div> : <div className="font-serif text-xl md:text-2xl font-bold text-brand-black text-center leading-tight mb-3" data-id="element-181">
                  {partner.name}
                </div>}
              <div className="text-xs text-brand-teal font-semibold uppercase tracking-wider" data-id="element-182">
                {partner.type}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}